import { matchSchema } from "../schemas/match";
import type { ListParams } from "./games";
import { fetchApi, paginatedSchema, toSearchParams } from "./internal";

export const matches = {
	list: (params: ListParams = {}) => {
		const qs = toSearchParams(params);
		return fetchApi(`/admin/matches${qs ? `?${qs}` : ""}`, paginatedSchema(matchSchema));
	},
	get: (id: string) => fetchApi(`/admin/matches/${id}`, matchSchema),
};
